import Container from '@/components/Container';
import { Filters } from './components/filters';
import { Results } from './components/results';
import { useReflectionVideos } from './hooks/useReflectionVideos';
import { useReflectionVideosStore } from './store/useSearchStore';
import { LoadingContainer } from '../reporting-tools/components/loading-container';
import { Suspense } from 'react';

export const ReflectionVideosScreenComponent = () => {
  const { loading } = useReflectionVideos();
  const page = useReflectionVideosStore((state) => state.page.page);

  return (
    <Container className="mt-8">
      <div className="col-span-12">
        <h1 className="font-cadiz text-sh-28-32 font-bold">{page?.title}</h1>
        <p className="mt-2 font-cadiz text-sh-xs">{page?.description}</p>
        <Filters />
        <Results loading={loading} />
      </div>
    </Container>
  );
};

export const ReflectionVideosScreen = () => {
  return (
    <Suspense fallback={<LoadingContainer title="Loading reflection videos..." />}>
      <ReflectionVideosScreenComponent />
    </Suspense>
  );
};
